<svg
  [attr.fill]="fill"
  [attr.height]="size"
  [attr.width]="size"
  [ngClass]="classList">
  <use attr.xlink:href="assets/icons-sheet.svg#{{ icon | lowercase }}"></use>
</svg>
